import * as React from 'react';
import cx from 'classnames';
import { Tabs } from './components/tabs';
import { I18n } from 'react-redux-i18n';
import { useQuestionnaireManagementController } from './questionnaire-management.controller';
import { QuestionnaireManagementProps } from './questionnaire-management.types';
import { Loading } from '@common/components/loading';

import './questionnaire-management.styles.scss';

export const QuestionnaireManagement: React.FC<QuestionnaireManagementProps> = (props) => {
  const { disabled, questionnaire, className, loading } = props;
  
  const {
    containerRef,
    tabsErrors,
    currentTab,
    setCurrentTab,
    tabsConfig,
  } = useQuestionnaireManagementController(props);

  return (
    <div className={cx('FhqDesignToolQuestionnaireManagement', { 'FhqDesignToolQuestionnaireManagement--disabled': disabled || !questionnaire }, className)}>
      <Tabs 
        errors={tabsErrors}
        className="FhqDesignToolQuestionnaireManagement__tabs"
        value={currentTab}
        onChange={setCurrentTab}
      />
      <div className="FhqDesignToolQuestionnaireManagement__container" ref={containerRef as React.MutableRefObject<HTMLDivElement | null>}>
        {loading 
          ? <Loading margin="30px" size={20} />
          : currentTab 
            ? tabsConfig[currentTab].component 
            : <h6 className="FhqDesignToolQuestionnaireManagement__container__no-data-msg">{I18n.t('Please select a questionnaire')}</h6>
        }
      </div>
    </div>
  );
};